import CalComDialog from "../../components/calComDialog/calComDialog.jsx";
import ConsultationInterstitialLayout from "./consultationInterstitial/ConsultationInterstitialLayout.jsx";
import { CAL_COM_KFT_URL } from "./consultationInterstitial/calComKftUrl.js";
import { KFT_INTERSTITIAL_OPTIONS } from "./consultationInterstitial/kftInterstitialOptions.js";

/**
 * Shown right after Cégjelző auto-lookup infers a "kft" company type — same
 * copy/choice as CommonKftInterstitial (the manual-pick equivalent), but a
 * distinct component so goTo/goBack (which resolve targets via
 * WIREFRAME_STEPS.findIndex(component identity)) can tell the two apart.
 */
const CommonKftCegjelzoInterstitial = ({
  selection,
  onSelectionChange,
  bookingDialogOpen,
  onBookingDialogOpenChange,
}) => {
  return (
    <>
      <ConsultationInterstitialLayout
        titleKey="searchflow.kftinterstitialtitle"
        subtitleKey="searchflow.kftinterstitialsubtitle"
        options={KFT_INTERSTITIAL_OPTIONS}
        selection={selection}
        onSelectionChange={onSelectionChange}
      />
      <CalComDialog
        open={bookingDialogOpen}
        onClose={() => onBookingDialogOpenChange(false)}
        url={CAL_COM_KFT_URL}
      />
    </>
  );
};

export default CommonKftCegjelzoInterstitial;
